
export default () => ({
  apiKey: null,
  access: false,
  isLoading: false,
  loginForm: {
    login: null,
    password: null
  },
  loginFormErrors: [],
  accesses: {
    main: true,
    contacts: true,
    countries: true,
    nestedForGuests: true,
    nestedForAgents: true,
    nestedForIndividuals: true,
    favorites: true,
    lk: true,
    search: true,
    result: true,
    cart: true,
    price: true,
    booking: true,
    agencyPrice: true,
    orders: true,
    sale: true,
    editSale: true,
    events: true,
    editEvents: true,
    editBanner: true,
    phonesForIndividuals: true,
    phonesForAgents: true,
  }
})
